export type MenuHealthCode = 'menu' | 'menuNotLive';

export type OnlineChannel = 'PICKUP' | 'DELIVERY';

export interface MenuHealthInput {
  enabledOnlineChannels: OnlineChannel[];
  menuCount: number;
  hasProducts: boolean | null;
  liveChannels: string[] | null;
}

export function hasProductsOf(
  trees: { categories: { products: unknown[] }[] }[],
  incomplete: boolean,
): boolean | null {
  if (trees.some((t) => t.categories.some((c) => c.products.length > 0))) return true;
  return incomplete ? null : false;
}

export function menuHealthOf(input: MenuHealthInput): MenuHealthCode | null {
  if (input.enabledOnlineChannels.length === 0) return null;
  if (input.menuCount === 0) return 'menu';
  if (input.hasProducts === null) return null;
  if (!input.hasProducts) return 'menu';
  const live = input.liveChannels;
  if (live === null) return null;
  return input.enabledOnlineChannels.some((channel) => !live.includes(channel))
    ? 'menuNotLive'
    : null;
}
